import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

const ProductImagesContainer = styled.div`
    flex: 1;

    .product-images-wrapper {
        display: flex;
        ${media.large`display: block;`}
        .primary-photo-container {
            flex: 3;
            order: 2;
            .gatsby-image-wrapper {
                max-width: 550px;
                margin: 0 auto;
            }
        }
        .photo-thumbnails-container {
            flex: 1;
            order: 1;
            ul {
                padding: 0;
                margin: 0 auto;
                list-style: none;
                max-width: 550px;
                ${media.large`display: flex;flex-wrap: wrap;`}
                li {
                    flex: 0 0 25%;
                    text-align: center;
                    button {
                        background-color: #fff;
                        border: none;
                        width: 100%;
                        max-width: 100px;
                        padding: 0;
                    }
                }
            }
        }
    }
`;

const ProductImages = ({ product, images }) => {
    const [currentMainImage, setCurrentMainImage] = useState();

    useEffect(() => {
        let doesProductHaveImage = images[0] && images[0].localFile;
        doesProductHaveImage &&
            setCurrentMainImage(images[0].localFile.childImageSharp.fluid);
    }, [images]);

    return (
        <ProductImagesContainer>
            <Wrapper className="product-images-wrapper">
                <div className="primary-photo-container">
                    <Img fluid={currentMainImage} />
                </div>
                <div className="photo-thumbnails-container">
                    <ul>
                        {images &&
                            images.map((image, index) => {
                                return (
                                    <li key={index}>
                                        <button
                                            onClick={() =>
                                                setCurrentMainImage(
                                                    image.localFile
                                                        .childImageSharp.fluid
                                                )
                                            }
                                        >
                                            <Img
                                                fluid={
                                                    image.localFile
                                                        .childImageSharp.fluid
                                                }
                                            />
                                        </button>
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            </Wrapper>
        </ProductImagesContainer>
    );
};

export default ProductImages;
